import styled from 'styled-components';

import { ArticleSection } from 'editorial/components/ArticleSection';
import { IArticleCreditsSection, IArticleSectionAdditionalProps } from 'editorial/types';
import { createSanitizedHtmlObject } from 'shared/utils/createSanitizedHtml';
import { variableFontRegular } from 'styles/theme/text';
import { useRouter } from 'next/router';
import { localizeUrl } from 'localization/utils/localizeUrl';

export const ArticleCredits = ({
  text,
}: IArticleCreditsSection & IArticleSectionAdditionalProps) => {
  const { locale } = useRouter();
  return (
    <ArticleSection>
      <ArticleCredits.ContentWrapper>
        <ArticleCredits.Text
          dangerouslySetInnerHTML={createSanitizedHtmlObject(localizeUrl(text, locale))}
        />
      </ArticleCredits.ContentWrapper>
    </ArticleSection>
  );
};

ArticleCredits.ContentWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: none;
`;

ArticleCredits.Text = styled.div`
  ${variableFontRegular({ size: '14px', height: '16px' })};
  letter-spacing: -0.01em;
  text-transform: uppercase;

  p {
    margin: 0;
  }
`;
